import script from "./ProductDemo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDemo.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDemo.vue?vue&type=style&index=0&id=eb8c32fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb8c32fe"]])

export default __exports__